import React from "react";
import { TraitSale } from "types";

export type TraitSalesContextValue = {
  traitSales: TraitSale[];
  traitSalesMap: Record<number, TraitSale>;
};

const TraitSalesContext = React.createContext<TraitSalesContextValue>({
  traitSales: [],
  traitSalesMap: {},
});

export default TraitSalesContext;
